import { useCallback, useEffect, useState } from 'react';
import { CartItem } from 'lib/util/cart';
import Router from 'next/router';
import classNames from 'classnames';
import Button from 'components/helpers/Button';
import { useCart } from 'components/helpers/Cart/CartHelper';
import {
  ProductItemRP,
  PurchaseInformationDataLayerObject,
  gtmEcommerceDatalayerPush,
} from 'lib/util/gtm-datalayer';

export type OrderDataProps = {
  FirstName?: string;
  LastName?: string;
  Company?: string;
  Address?: string;
  City?: string;
  State?: string;
  Zip?: string;
  Country?: string;
  Phone?: string;
  Email?: string;
  User?: string;
  ShippingMethod?: string;
  FedExNumber?: string;
  FedExRushMethod?: string;
  OrderedProducts?: CartItem[];
  EmailItemId?: string;
};

const MailOrder = (OrderData: OrderDataProps): JSX.Element => {
  const [failtoOrder, SetFailToOrder] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const closeModal = () => {
    setIsOpen(false);
    Router.push('/cart');
  };
  const OrderSummary = JSON.stringify(OrderData);
  const { ShippingMethod } = OrderData;
  const { clearCart, fetchCart } = useCart();

  const ClearuserCart = useCallback(() => {
    clearCart();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const pushPurchaseInformationGTM = () => {
    const items = fetchCart().map((item, i) => {
      return {
        item_id: item.itemNumber ?? item.id,
        item_name: item.name,
        affiliation: 'N/A',
        coupon: 'N/A',
        discount: 'N/A',
        index: i.toString(),
        item_brand: 'NMDP',
        item_list_name: 'order materials',
        item_variant: 'N/A',
        price: item.price,
        quantity: item.quantity,
      };
    }) as ProductItemRP[];

    const gmtData: PurchaseInformationDataLayerObject = {
      event: 'purchase',
      ecommerce: {
        transaction_id: 'N/A',
        value: '0',
        tax: 'N/A',
        shipping: ShippingMethod,
        currency: 'USD',
        coupon: 'N/A',
        items: items,
      },
    };
    gtmEcommerceDatalayerPush(gmtData);
  };

  useEffect(() => {
    const mailOrderData = async () => {
      const anitForgeryTokenResponse = await fetch(
        '/api/sitecore/NmdpUtility/GenerateAntiForgeryToken'
      );
      const result = await anitForgeryTokenResponse.text();
      const template = document.createElement('template');
      template.innerHTML = result;
      const antiForgeryInput = template.content.querySelector('input') as HTMLInputElement;
      const formData = new FormData();
      formData.append('__RequestVerificationToken', antiForgeryInput.value);
      formData.append('body', OrderSummary);
      return fetch(`/api/sitecore/NmdpUtility/PlaceOrder`, {
        method: 'POST',
        body: formData,
      });
    };
    const res = mailOrderData();
    res
      .then((response) => {
        if (response.ok) {
          pushPurchaseInformationGTM();
          ClearuserCart();
          Router.push('/cart/order-confirmation');
        } else {
          SetFailToOrder(true);
          setIsOpen(true);
        }
      })
      .catch(() => {
        SetFailToOrder(true);
        setIsOpen(true);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ClearuserCart, OrderSummary]);
  return (
    <>
      {failtoOrder && isOpen && (
        <div className={classNames('fixed z-50')}>
          <div className={classNames('modal-overlay fixed inset-0 z-[100] bg-black opacity-50')} />
          <div
            className={classNames(
              'modal-container tt-center fixed left-[50%] top-[50%] z-50 z-[10000] w-[90%] overflow-y-auto rounded-[12px] bg-white shadow-lg md:mx-auto md:w-1/2 lg:w-1/3'
            )}
          >
            <div className={classNames('modal-content relative px-6 py-4 text-left')}>
              <div className={classNames('absolute right-[16px] top-[8px]')}>
                <button
                  type="button"
                  className={classNames('modal-close ml-auto rounded-full text-4xl text-black')}
                  onClick={() => {
                    closeModal();
                  }}
                >
                  &times;
                </button>
              </div>
              <p className={classNames('mb-[30px] text-body leading-4')}>
                There is a problem with your Order. Please try again
              </p>
              <div>
                <Button
                  variant="secondary"
                  className={classNames(
                    'mb-4 w-full border-2 py-[7px] text-center md:mr-[16px] md:w-auto'
                  )}
                  onClick={() => {
                    closeModal();
                  }}
                >
                  Try Again
                </Button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default MailOrder;
